import { useCallback, useContext, useEffect, useState } from 'react';
import api from '../services/api';
import { AuthContext } from '../contexts/AuthContext';
import { HrTimeclockInboxSummary } from '../types';

export const HR_GESTAO_PONTO_LINK = '/ponto-eletronico?tab=gestao&focus=correcoes';
export const HR_GESTAO_NF_LINK = '/ponto-eletronico?tab=gestao&focus=notas-fiscais';

export function useHrGestaoInbox(): {
  pendingTimeCorrections: number;
  pendingInvoices: number;
  totalPending: number;
  loading: boolean;
  refresh: () => Promise<void>;
} {
  const { user } = useContext(AuthContext) || {};
  // RH/admin: caixa global. Gestor: pendências do próprio + time (correções) / time (NF).
  const canSeeInbox =
    user?.role === 'hr' || user?.role === 'admin' || user?.role === 'manager';
  const [summary, setSummary] = useState<HrTimeclockInboxSummary | null>(null);
  const [loading, setLoading] = useState(false);

  const refresh = useCallback(async (): Promise<void> => {
    if (!canSeeInbox) {
      setSummary(null);
      return;
    }
    setLoading(true);
    try {
      const res = await api.get<HrTimeclockInboxSummary>('/timeclock/hr/inbox-summary');
      setSummary(res.data);
    } catch {
      setSummary(null);
    } finally {
      setLoading(false);
    }
  }, [canSeeInbox]);

  useEffect(() => {
    void refresh();
    if (!canSeeInbox) return;
    const id = window.setInterval(() => void refresh(), 60000);
    return () => window.clearInterval(id);
  }, [canSeeInbox, refresh]);

  const pendingTimeCorrections = summary?.pendingTimeCorrections ?? 0;
  const pendingInvoices = summary?.pendingInvoices ?? 0;

  return {
    pendingTimeCorrections,
    pendingInvoices,
    totalPending: pendingTimeCorrections + pendingInvoices,
    loading,
    refresh,
  };
}
